/**
 * Asks layout form (e.g. what-thread-unlocks, not-solving).
 *
 * The "asks" slide is the payoff layout — a heading, a sub-heading,
 * and a card grid (capabilities, asks, or scope-limits). Each card has
 * a coloured top border (orange for "promise", green for "delivered")
 * and a single short paragraph.
 */

import type { Slide, SlideUpdatePayload } from "../types";
import { CommonSlideFields } from "./CommonSlideFields";
import { LayoutHint } from "./LayoutHint";
import { TextArea } from "./FormPrimitives";

interface AsksFormProps {
  draft: Slide;
  setField<K extends keyof SlideUpdatePayload>(
    key: K,
    value: SlideUpdatePayload[K],
  ): void;
  flush(): void;
}

export function AsksForm({ draft, setField, flush }: AsksFormProps) {
  return (
    <div data-testid="layout-form-asks">
      <LayoutHint title="Asks slide (card grid)">
        Heading + <code>&lt;h2&gt;</code> kicker + a grid of <code>.card</code>
        cells. Use <code>border-top: 2px solid var(--fc-orange)</code> for
        promises, green for delivered capabilities.
      </LayoutHint>
      <CommonSlideFields draft={draft} setField={setField} flush={flush} />
      <TextArea
        label="Body HTML (heading + card grid)"
        value={draft.bodyHtml}
        onChange={(v) => setField("bodyHtml", v)}
        onBlur={flush}
        rows={14}
        testId="slide-body-html-input"
      />
    </div>
  );
}
